import { useContext, useEffect, useMemo, useState } from "react"
import { callautopopulate } from "../../../services/callautopop";
import { ToastContext } from "../../../context/ToastContext";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import _ from "underscore";
import { dateConvert } from "../../../utils/Helper";

export const useReceiveAsset = ({ onClose, editData, dropdownOpts, handleAssetDetails }) => {

    const { showSuccess, showError, showInfo } = useContext(ToastContext);
    const [options, setOptions] = useState({ receive_by: [] });
    const [fieldValues, setFieldValues] = useState({ receive_by: {}, returned_date: new Date(), other_assets: [], media: [], remark: "", is_exit: false });
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        callautopopulate("assets_assignee").then((res) => {
            setOptions((prev) => ({ ...prev, receive_by: res?.assets_assignee }));
            if (res?.assets_assignee?.length === 1) {
                setFieldValues((prev) => ({ ...prev, receive_by: res?.assets_assignee?.[0] }));
            }
        })

        // handle additionally assigned assets
        let otherAssets = [];
        editData?.child_assets?.forEach(item => {
            const childAssetIds = item?.child_asset_ids?.split(",");
            const childUniqueIds = item?.child_assets_unique_ids?.split(",");
            const childTransIds = item?.child_trans_ids?.split(",");
            childAssetIds?.forEach((child, idx) => {
                otherAssets?.push({
                    asset_id: parseInt(child),
                    asset_unique_id: childUniqueIds?.[idx],
                    asset_trans_id: parseInt(childTransIds?.[idx]),
                })
            })
        })
        const assets = _.sortBy(_.filter(dropdownOpts?.assets_details, item => !item?.is_asset_assign && item?.asset_id !== editData?.asset_id && item?.asset_type_id === editData?.asset_type_id), "asset_unique_id");
        let all = {};
        dropdownOpts?.assets_details?.forEach(item => all[item?.asset_id] = item?.asset_unique_id);
        setOptions((prev) => ({ ...prev, other_assets: otherAssets, assets_details: assets}));
        setFieldValues((prev) => ({...prev, other_assets: otherAssets}))
    }, [])

    const handleReceive = async () => {
        try {
            if (_.isEmpty(fieldValues?.receive_by)) {
                showInfo("Info", "Please select receive by");
                return;
            } else if (!fieldValues?.remark) {
                showInfo("Info", "Please write receive remark");
                return;
            }
            setLoader(true);

            // format media tvp array
            let mediaTvpArray = [];
            fieldValues?.media?.forEach((item) => {
                const transData = _.filter(editData?.assigned_history, (obj) => obj?.asset_unique_id === editData?.asset_unique_id && obj?.asset_trans_type?.trim()?.toLowerCase() === "a");
                const mediaData = _.filter(editData?.trans_media, (obj) => _.isEqual(obj?.media_obj, item));
                mediaTvpArray.push({
                    "asset_unique_id": editData?.asset_unique_id || "",
                    "media_file_id": mediaData?.[0]?.details?.media_file_id || 0,
                    "asset_tran_id": transData?.[0]?.asset_tran_id || 0,
                    "asset_base64_string": item?.base64 || "",
                    "asset_unique_file_id": ""
                })
            })

            // media tvp array of other assets assigned together
            if(!fieldValues?.is_replace) {
                options?.other_assets?.forEach((item) => {
                    const transData = _.filter(editData?.all_history, (obj) => obj?.asset_unique_id === item?.asset_unique_id && obj?.asset_trans_type?.trim()?.toLowerCase() === "a");
                    fieldValues?.[item?.asset_unique_id]?.forEach(media => {
                        mediaTvpArray.push({
                            "asset_unique_id": item?.asset_unique_id || "",
                            "media_file_id": 0,
                            "asset_tran_id": transData?.[0]?.asset_tran_id || 0,
                            "asset_base64_string": media?.base64 || "",
                            "asset_unique_file_id": ""
                        })
                    })
                })
            }

            // set trans ids
            const replaceFlag = fieldValues?.is_exit ? false : fieldValues?.is_replace;
            const transIdArray = replaceFlag ? [editData?.is_currently_assigned?.asset_tran_id] : [editData?.is_currently_assigned?.asset_tran_id, ..._.pluck(fieldValues?.other_assets, "asset_trans_id")];
            const payload = {
                "asset_tran_ids": transIdArray?.toString() || "",
                "assets_receive_media": mediaTvpArray || [],
                "assets_assignee_id": fieldValues?.receive_by?.assets_assignee_id || 0,
                "returned_date": dateConvert(fieldValues?.returned_date || new Date(), "iso-string")?.split("T")?.[0] || "",
                "returned_remark": fieldValues?.remark || "",
                "is_exit": fieldValues?.is_exit?.toString() || "false",
                "is_asset_replace": replaceFlag || false,
                "asset_id": (replaceFlag ? fieldValues?.replace_asset?.asset_id : 0) || 0,
                "assigned_user_code": (replaceFlag ? editData?.is_currently_assigned?.user_code : 0) || 0,
            }
            const res = await services.getInvokeRemote("POST", Urls("SAVEASSETSRECEIVE"), payload);
            if (res) {
                showSuccess("success", res?.body?.message);
                setLoader(false);
                handleAssetDetails()
                onClose();
            }
        } catch (error) {
            console.error("Error receiving asset: ", error);
            showError("error", error?.response?.data?.errorMessage);
            setLoader(false);
        }
    }

    const handleReset = () => {
        setFieldValues({ receive_by: {}, media: [], remark: "" });
    }


    return useMemo(() => ({
        options, fieldValues, setFieldValues, handleReset, handleReceive, loader
    }), [options, fieldValues, setFieldValues, handleReset, handleReceive, loader])
}